import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addSustancia, removePuestosAsociados, removeSustancias, setEditSustancia, } from "../../../../redux/actions/resolucion";
import ConfirmDialog from "../../../commons/dialog/ConfirmDialog";
import SustanciasFormContainer from "./formSustancia/SustanciasFormContainer";
import SustanciasTable from "./SustanciasTable";

const SustanciasContainer = ({ handleCancelResolucion, nextForm }) => {
  const dispatch = useDispatch();
  const [currentView, setCurrentView] = useState("table");
  const [openDeleteSustanciaWarning, setOpenDeleteSustanciaWarning] = useState(false)
  const [sustanciasToErase, setSustanciasToErase] = useState([]);
  const sustancias = useSelector(
    (state) => state.resolucion.postResolucion.sustancias
  );
  const puestos = useSelector(
    (state) => state.resolucion.postResolucion.puestos
  );

  const establecimiento = useSelector(
    (state) => state.resolucion.datosEstablecimiento
  );

  const idDependenciaEmpleador = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );

  const handleNextForm = () => {
    nextForm("PuestosAsociados");
  };

  const handleCancelSustancia = () => {
    setCurrentView("table");
  };

  const handleDeleteSustancias = () => {
    let puestosToDelete = puestos.filter((p) => p.sustancias?.some((sustId) => sustanciasToErase.map((r) => r.original.id).includes(sustId)));
    dispatch(removeSustancias(sustanciasToErase.map((s) => s.index)));
    dispatch(removePuestosAsociados(puestosToDelete));
    setOpenDeleteSustanciaWarning(false);
  };

  const handleOpenDeleteSustancias = (rowsToDelete, table) => {
    const idsToDelete = rowsToDelete.map((r) => r.index);
    if (!puestos.find((p) => p.sustancias?.some((sustId) => rowsToDelete.map((r) => r.original.id).includes(sustId)))) {
      dispatch(removeSustancias(idsToDelete));
      table.resetRowSelection();
    } else {
      setSustanciasToErase(rowsToDelete);
      setOpenDeleteSustanciaWarning(true);
    }
  }

  const handleOpenFormularioSustancia = (rowData = {}) => {
    dispatch(setEditSustancia(rowData, rowData?.index));
    setCurrentView("sustanciaForm");
  };

  const handleAddSustancia = (sustancia, id) => {
    dispatch(addSustancia(sustancia, id));
    setCurrentView("table");
  };

  return (
    <>
      {
        {
          table: (
            <SustanciasTable
              handleCancelResolucion={handleCancelResolucion}
              handleNextForm={handleNextForm}
              handleDeleteSustancias={handleOpenDeleteSustancias}
              data={sustancias}
              handleOpenFormularioSustancia={handleOpenFormularioSustancia}
              establecimiento={establecimiento}
            />
          ),

          sustanciaForm: (
            <SustanciasFormContainer
              setCurrentView={setCurrentView}
              handleCancelSustancia={handleCancelSustancia}
              submitSustancia={handleAddSustancia}
              idDependenciaEmpleador={idDependenciaEmpleador}
            />
          ),
        }[currentView]
      }
      <ConfirmDialog
        open={openDeleteSustanciaWarning}
        handleClose={() => setOpenDeleteSustanciaWarning(false)}
        handleConfirm={handleDeleteSustancias}
        title={"Eliminar Sustancias"}
        warningText={"Algunas sustancias estan asociada puestos. ¿Seguro que desea eliminarlas?."}
      />
    </>
  );
};

export default SustanciasContainer;
